import classnames from "classnames";
import React from "react";
import { Icon, Icomoon } from "../..";

import "./CircleButton.scss";

interface Props {
  /**
   * Icon to display in the button.
   * Positioned using `position: absolute`, so if not quite centred tweak with `top`, `left`, etc.
   */
  icomoon: string;
  direction: "left" | "right";

  /**
   * Text to use for the button.
   * If there's not enough space, try tweaking `margin-right` on `.circle-button__label`.
   */
  label?: string;
  onClick?: () => void;
  disabled?: boolean;
}

// eslint-disable-next-line max-len
const path = "M2.2,20.4C6.8,9.2,17.8,1.4,30.6,1.5c16.8,0.1,30.3,13.8,30.2,30.6S46.9,62.4,30.1,62.2 C16.8,62.2,5.5,53.4,1.5,41.4";

/**
 * Circular button to use on interactive pages.
 * 
 * @status stable
 */
export const CircleButton = ({ direction, disabled, onClick, icomoon, label }: Props) => {
  const className = classnames("circle-button", `circle-button--${icomoon}`, `circle-button--to-${direction}`);
  return (
    <button
      type="button"
      className={className}
      disabled={disabled}
      onClick={onClick}
      aria-label={label}
      onMouseLeave={e => e.currentTarget.blur()}
      onTouchEnd={e => e.currentTarget.blur()}
    >
      <div className="circle-button__flex-wrap">
        <label className={classnames("circle-button__label", "text--caps")}>{label}</label>

        <svg className="circle-button__svg" x="0px" y="0px" width="65px" height="65px" viewBox="0 0 65 65">
          <path className="circle-button__thin-circle" d={path} />
          <path className="circle-button__fat-circle" d={path} />
        </svg>

        <Icon icomoon={icomoon as Icomoon} />
      </div>
    </button>
  );
};
